export default __webpack_public_path__ + "fa69ad3c9dbc89f3a1e71e8b542144b7.jpg";